<template>
  <div class="d-inline-block">
    <button @click="openQrCodeModal()" class="btn btn-sm btn-info"> <i class="fa fa-qrcode"></i></button>
    <modal :name="`qr-modal-${componentId}`" :adaptive="true" height="auto">
      <div class="qr-wrapper">
        <div class="p-3">
          <div class="d-flex align-center justify-content-center mb-3">
            <button class="qr-button" @click="download">
              <div :id="componentId"></div>
            </button>
          </div>
          <div class="text-center mb-3">
            <button :class="{'btn-success': size === 150}" class="btn btn-sm mr-1" @click="size = 150">150</button>
            <button :class="{'btn-success': size === 200}" class="btn btn-sm mr-1" @click="size = 200">200</button>
            <button :class="{'btn-success': size === 300}" class="btn btn-sm mr-1" @click="size = 300">300</button>
            <button :class="{'btn-success': size === 400}" class="btn btn-sm mr-1" @click="size = 400">400</button>
            <button :class="{'btn-success': size === 500}" class="btn btn-sm mr-1" @click="size = 500">500</button>
          </div>
          <div class="text-center">
            <button @click="download" class="btn btn-small btn-info"><i class="fa fa-download"></i></button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import QRCodeStyling from 'qr-code-styling'

export default {
  props: {
    name: {
      type: String,
      default: 'qr-code'
    },
    link: {
      type: String,
      default: ''
    },
    initSize: {
      type: Number,
      default: 600
    }
  },
  data (vm) {
    return {
      componentId: vm._uid,
      qrCode: null,
      size: 300
    }
  },
  watch: {
    size: 'changeSize'
  },
  methods: {
    openQrCodeModal () {
      this.$modal.show('qr-modal-' + this.componentId)
      setTimeout(() => {
        this.bootQRcode()
      })
    },
    changeSize () {
      this.bootQRcode()
    },
    bootQRcode () {
      if (this.qrCode) {
        this.qrCode._container.getElementsByTagName('svg')[0].remove()
      }

      const qrCode = new QRCodeStyling({
        width: this.size,
        height: this.size,
        type: 'svg',
        data: this.link,
        image: `/qr-${this.size}.png`,
        dotsOptions: {
          color: '#008078',
          type: 'extra-rounded'
        },
        backgroundOptions: {
          color: '#ffffff'
        },
        imageOptions: {
          crossOrigin: 'anonymous',
          imageSize: 0.55,
          margin: 4
        },
        qrOptions: {
          // errorCorrectionLevel: 'M'
        }
      })

      this.qrCode = qrCode

      qrCode.append(document.getElementById(this.componentId))
    },
    download () {
      this.qrCode.download({ name: `qr-${this.name}-${this.size}`, extension: 'png' })
    }
  }
}
</script>
<style>
 .qr-button {
   display: block;
   border: 0;
   background: none;
   cursor: pointer;
 }
</style>
